module.exports = __webpack_public_path__ + "static/img/new.2feaeb5b.png";